module.exports = __webpack_public_path__ + "mx.svg?4e358e43beb776d5c90cca5ffec8a2bd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mx.svg
// module id = 1523
// module chunks = 0